<template>
  <div class="chre-box">
    <div class="left">
      <div class="one">
        <span class="l-top">公司全称:</span>
        <span>河南豫都包装有限公司</span>
      </div>
      <div>
        <span class="l-top">工厂地址:</span>
        <span>郑州北 平原示范区中原印刷包装产业园（中国印都）9栋</span>
      </div>
      <div>
        <span class="l-top">运营中心:</span>
        <span>河南国家大学科技园东区14栋16层</span>
      </div>
      <div>
        <span class="l-top">联系我们:</span>
        <span>13592507599</span>
      </div>
      <div>
        <span class="l-top">运营网址:</span>
        <span>www.std0371.com</span>
      </div>
      <div>
        <span class="l-top">营业时间:</span>
        <span>早9：00---晚7:30</span>
      </div>
      <div>
        <span class="l-top">客服QQ:</span>
        <span>707777599</span>
      </div>
      <div>
        <span class="l-top">客服电话:</span>
        <span>15637158984</span>
      </div>
    </div>
    <baidu-map class="right map" ak="YOUR_APP_KEY" :center="{lng: 113.781369, lat: 35.05393}" :zoom="15" :scroll-wheel-zoom="true">
     <bm-marker :position="{lng: 113.781369, lat: 35.05393}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
      <bm-label content="我的公司" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/>
    </bm-marker>
    </baidu-map>
  </div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
export default {
  components: {
    BaiduMap
  }
}
</script>

<style lang="less" scoped>
.iw_poi_content {
  font: 12px arial, sans-serif;
  overflow: visible;
  padding-top: 4px;
  white-space: -moz-pre-wrap;
  word-wrap: break-word;
}
.chre-box {
  margin-top: 40px;
  background: #fff;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  .left {
    width: 64%;
    height: 537px;
    .one {
      margin-top: 0;
    }
    div {
      display: flex;
      margin-top: 20px;
      span {
        display: block;
        line-height: 24px;
        font-size: 16px;
        color: #666666;
        width: 80%;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
      .l-top {
        width: 80px;
      }
    }
  }
  .right {
    width: 35%;
    height: 400px;
  }
}
</style>